module.exports = __webpack_public_path__ + "static/media/background-institucional-footer.cdd96383.png";